module.exports = __webpack_public_path__ + "static/img/11.e5de089.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/11.png
// module id = hWaG
// module chunks = 0